import { render, staticRenderFns } from "./ShareSidebar.vue?vue&type=template&id=83234a98&scoped=true&"
import script from "./ShareSidebar.vue?vue&type=script&lang=js&"
export * from "./ShareSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ShareSidebar.vue?vue&type=style&index=0&id=83234a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83234a98",
  null
  
)

export default component.exports